import { createContext, use } from "react";

export type ButtonTypography = "v1" | "v2";

/** v1 is the pre-Typography-v2 styling, kept behind the front `typography-v2-buttons` flag until rollout. */
const ButtonTypographyContext = createContext<ButtonTypography>("v2");
ButtonTypographyContext.displayName = "ButtonTypographyContext";

export const ButtonTypographyProvider = ButtonTypographyContext;

export function useButtonTypography(): ButtonTypography {
  return use(ButtonTypographyContext);
}
